// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import AdminResourceHistoryTable from 'components/organisms/AdminResourceHistoryTable/AdminResourceHistoryTable';
import { AdminTemplate } from 'components/templates/AdminTemplate';
import { useTranslation } from 'react-i18next';
import { Path } from 'routes';

const AdminEmissionResourceHistory = () => {
  const { t } = useTranslation();
  return (
    <AdminTemplate
      h1={t('resource_list_screen.title')}
      active={'履歴'}
      breadcrumb={[
        { label: 'データ編集', href: Path.adminEmissionResourceHistory },
        { label: '履歴' },
      ]}
    >
      <AdminResourceHistoryTable />
    </AdminTemplate>
  );
};

export default AdminEmissionResourceHistory;
